import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ListDropdownGroupItem } from "../../../rubbl-shared/rubbl-shared";

@Component({
  selector: "common-faq-dropdown-list",
  templateUrl: "./faq-dropdown-list.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqDropdownListComponent {
  listGroupItems: ListDropdownGroupItem[] = [
    {
      header: "What is Rubbl?",
      body:
        "Rubbl is the first fully-managed online heavy equipment rental marketplace, providing real-time access to high-quality vetted contractor-owned equipment. Every rental comes with extensive damage coverage, managed transportation logistics, reliable service coverage, and a dedicated rental pro!",
      toggled: false,
    },
    {
      header: "What kind of equipment can I find on the Rubbl marketplace?",
      body:
        "Currently, our inventory includes heavy civil, earthmoving equipment such as excavators, dozers, scrapers, motor graders, loaders, water trucks, and compactors but plan to expand our inventory in the future. Looking for a particular machine that you don't see? Reach out to us today.",
      toggled: false,
    },
    {
      header: "How do I start renting from Rubbl?",
      body:
        "To get started, search for the machines that fit your needs, add them to your cart, and easily check out (just like at Amazon). During checkout, we’ll ask for your existing insurance coverage information and run a credit check. Rubbl will then schedule, coordinate, and transport all of your gear to your job site. The entire process only takes a few minutes.",
      toggled: false,
    },
    {
      header: "What can I expect from a Rubbl Rental?",
      body:
        "When you rent from Rubbl, you’re getting more than just vetted, well maintained newer equipment, you’re also getting damage coverage, maintenance, transportation logistics, and managed services with all rentals, you'll always have dedicated support and transparency throughout the entire process.",
      toggled: false,
    },
  ];

  constructor() {}
}
